import { useCallback, useMemo } from "react";
import IconListDropdown, { Option } from "./IconListDropdown";
import CompanyService from "../services/CompanyService";

export default function ActivityTypeIconDropdown({
  title = "Tipo de gestión",
  value,
  onChange
}: {
  title?: string;
  value?: string | number;
  onChange: (val?: string | number) => void;
}) {
  const baseOptions: Option[] = useMemo(() => {
    const list = (CompanyService.getActivityTypes() ?? [])
      .filter((x: any) => x.Mail)
      .map((x: any) => ({
        value: x.ActivityTypeID as string | number,
        label: x.ActivityTypeName as string
      }));
    return list;
  }, []);

  const optionsWithNone: Option[] = useMemo(
    () => [{ value: "", label: "Ninguno" }, ...baseOptions],
    [baseOptions]
  );

  const hasSelection =
    value !== undefined && value !== null && `${value}`.length > 0;

  const handleChange = useCallback(
    (val?: string | number) => {
      if (
        val === "__none__" ||
        val === undefined ||
        val === null ||
        val === ""
      ) {
        onChange("");
      } else {
        onChange(val);
      }
    },
    [onChange]
  );

  return (
    <IconListDropdown
      title={title}
      iconClass={`fa-solid fa-list ${hasSelection ? "text-primary" : "text-muted"}`}
      options={optionsWithNone}
      multiple={false}
      value={value}
      onChange={handleChange}
    />
  );
}
